import { post, get } from '../../http'
import { FIXUP_URL, ZHIBO_URL, MARKET_URL, LIVE_GW_URL } from '../../baseUrl'

/**
 * @method 获取训练营列表
 * @param {integer} page 页码
 * @param {integer} size 页数
 * @param {integer} type 类型(2待开课、3开课中、4已结束)
 */
export function postPeriodList(params) {
  return post(`${ZHIBO_URL}/v1/period/period_list`, params, false, {
    zhibo: true
  })
}

/**
 * @method H5营期详情页面信息
 * @param {integer} id 营期id
 * @param {integer} page
 * @param {integer} size
 */
export function postPeriodDetails(params) {
  return post(`${ZHIBO_URL}/v1/period/period_details`, params, false, {
    zhibo: true,
    allResolve: true
  })
}

/**
 * @method H5营期加入学习、以及记住密码状态
 * @param params
 * @returns {*|Promise|Promise<unknown>}
 */
export function postAddStudent(params) {
  return post(`${ZHIBO_URL}/v1/student/add`, params, false, { zhibo: true })
}

/**
 * @method 获取自定义菜单训练营ids集合
 * @param params {integer} topicId 话题Id
 * @returns {*|Promise|Promise<unknown>}
 */
export function getPublicTopicMenu(params) {
  return get(`${FIXUP_URL}/api/v1/public/TopicMenu/traincamps`, params, false)
}

/**
 * @method 获取自定义菜单id集合
 * @param params {integer} topicId 话题Id
 * @param params {integer} menuType 菜单ID
 * @returns {*|Promise|Promise<unknown>}
 */
export function getTopicMenuContent(params) {
  return get(`${FIXUP_URL}/api/v1/public/TopicMenu/menu_content`, params, false)
}

/**
 * @method
 * @param params {integer} page
 * @param params {integer} size
 * @param params {Array} trainingCampPeriodIdList
 * @returns {*|Promise|Promise<unknown>}
 */
export function postPeriodMenuList(params) {
  return post(`${ZHIBO_URL}/v1/period/menu/list`, params, false, {
    zhibo: true
  })
}

export function getZbAuthUrl(params) {
  return get(`${ZHIBO_URL}/v1/login/get_zb_auth_url`, params, false, {
    zhibo: true
  })
}

// 获取用户账号状态
export function getAccountStatus(params) {
  return get(`${ZHIBO_URL}/v1/account/status?token=${params.token}`, {}, false)
}

// 获取滑块验证图片
export function getValidateImage(params) {
  return get(`${ZHIBO_URL}/v1/login/get_validate_image`, params, false)
}

// 校验滑块验证图片
export function checkValidateImage(params) {
  return post(
    `${ZHIBO_URL}/v1/login/check_validate_image?horizontalPosition=${params.horizontalPosition}&validaId=${params.validaId}`,
    {},
    false
  )
}

// 手机短信登录[枚举: 1:手机注册,2:手机登录,3:修改密码,4:忘记密码]
export function loginByPhoneCode(params) {
  return post(`${ZHIBO_URL}/v1/login/login_by_phone_code`, params, false)
}

// 手机号密码登录
export function loginByPhonePassword(params) {
  return post(`${ZHIBO_URL}/v1/login/login_by_phone_password`, params, false)
}

// 短信发送
export function smsSend(params) {
  return post(`${ZHIBO_URL}/v1/login/sms_send`, params, false)
}

// 短信发送[枚举: 1: 手机注册, 2: 手机登录, 3: 修改密码, 4: 忘记密码]
export function smsSendCheck(params) {
  return post(
    `${ZHIBO_URL}/v1/login/sms_send_check?authorization=${params.authorization}&phone=${params.phone}&smsSign=${params.smsSign}&type=${params.type}&validaId=${params.validaId}&zbid=${params.zbid}`,
    {},
    false
  )
}

// 获取用户信息
export function postCampUserInfo(params) {
  return post(`${ZHIBO_URL}/v1/user/info`, params, false, { zhibo: true })
}

// 根据当前用户及传入手机，校验权限
export function postCampCheckStudentPhone(params) {
  return post(`${ZHIBO_URL}/v1/student/check_student_phone`, params, false, {
    zhibo: true
  })
}

// 获取用户已领取的优惠券列表
export const getHadGotCouponList = params =>
  post(`${MARKET_URL}/api/v1/coupon/GetHadGotCouponList`, params, false)

// 根据课程id或课节id获取课程或课节的信息
export function postCourseChapterListInfo(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/course_chapter/mix/info`,
    params,
    false,
    { zhibo: true }
  )
}
// 获取学分排行-getCreditRanking
export function getCreditRanking() {
  return get(
    `${LIVE_GW_URL}/train/v1/cus/credit/getCreditRanking`,
    null,
    true,
    { zhibo: true }
  )
}

// 获取我的学分-getMyCredit
export function getMyCredit() {
  return get(`${LIVE_GW_URL}/train/v1/cus/credit/getMyCredit`, null, true, {
    zhibo: true
  })
}

// 获取推荐内容-getRecommendedContent
export function getCreditRecommendedContent() {
  return get(
    `${LIVE_GW_URL}/train/v1/cus/credit/getRecommendedContent`,
    null,
    true,
    { zhibo: true }
  )
}

// 获取学分记录-pageCreditRecord
export function getPageCreditRecord(params, loading) {
  return get(
    `${LIVE_GW_URL}/train/v1/cus/credit/pageCreditRecord`,
    params,
    loading,
    { zhibo: true }
  )
}

// 获取学分任务-pageCreditTask
export function getPageCreditTask(params, loading) {
  return get(
    `${LIVE_GW_URL}/train/v1/cus/credit/pageCreditTask`,
    params,
    loading,
    { zhibo: true }
  )
}

// 通过学分任务id获取其对应的课程、课节、话题列表（分页）-pageTaskRelation
export function getPageTaskRelation(params, loading) {
  return post(
    `${LIVE_GW_URL}/train/v1/cus/credit/pageTaskRelation`,
    params,
    loading,
    { zhibo: true }
  )
}

// 获取用户学习情况
export function getLearnOverview(params) {
  return get(`${ZHIBO_URL}/v1/learn/overview`, params, true, { zhibo: true })
}
// 获取用户学习记录
export function postLearnRecord(params, loading = false) {
  return post(`${ZHIBO_URL}/v1/learn/record`, params, loading, { zhibo: true })
}
